import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=4918d7a8&"
import script from "./CardInfo.vue?vue&type=script&lang=js&"
export * from "./CardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports